import styled from 'styled-components';
import { sizes } from 'style';
import { th } from 'style/theme';
import Popup from './components/Popup';

export const PopupTexts = styled.div`
  padding: 1em;

  > h2 {
    padding-bottom: 0.5em;
    font-size: 30px;
    color: ${th('colors.white')};
    margin: 0;
  }

  > p {
    margin: 0;
    margin-bottom: 24px;
  }

  > :last-child {
    margin: 0;
  }
`;

export const StyledPopup = styled(Popup)`
  display: grid;
  grid-template-rows: auto 300px;
  width: 90%;
  max-width: 840px;
  background-color: ${th('colors.turquoise')};

  @media ${sizes.tabletPortrait} {
    grid-template-rows: auto;
    grid-template-columns: 5fr 4fr;
  }

  > img {
    box-sizing: border-box;
    width: auto;
    height: 100%;
    padding: 1em;
    margin: 0 auto;
    align-self: center;

    @media ${sizes.tabletPortrait} {
      width: 100%;
      height: auto;
      padding: 2em;
    }

    @media ${sizes.desktop} {
      padding: 3em;
    }
  }

  > ${PopupTexts} {
    @media ${sizes.tabletPortrait} {
      padding: 2em;
    }

    @media ${sizes.desktop} {
      padding: 4em 2em;
    }

    > h2 {
      max-width: 300px;
    }
  }
`;

export const PopupWithoutImage = styled(Popup)`
  display: block;
  background-color: ${th('colors.turquoise')};
`;
